import React, { useState } from 'react'
import './Header.css'
import { FaAngleDown } from "react-icons/fa6";
import { Link } from 'react-router-dom';
import { FaBarsStaggered } from "react-icons/fa6";



const Header = () => {

    return (
        <>
            <header>
                <nav className="navbar navbar-expand-lg">
                    <div className="container">
                        <Link className="navbar-brand" to="/">
                            <img src={require('../../assets/images/logo.png')} alt='logo' />
                        </Link>
                        <button
                            className="navbar-toggler"
                            type="button"
                            data-bs-toggle="collapse"
                            data-bs-target="#navbarSupportedContent"
                            aria-controls="navbarSupportedContent"
                            aria-expanded="false"
                            aria-label="Toggle navigation"
                        >
                            <FaBarsStaggered />
                        </button>
                        <div className="collapse navbar-collapse" id="navbarSupportedContent">
                            <ul className="navbar-nav ms-auto mb-2 mb-lg-0">
                                
                                {/* <li className="nav-item dropdown">
                                    <a
                                        className="nav-link"
                                        href="#"
                                        role="button"
                                        data-bs-toggle="dropdown"
                                        aria-expanded="false"
                                    >
                                        Demos <FaAngleDown />
                                    </a>
                                    <ul className="dropdown-menu">
                                        <li><a className="dropdown-item" href="#">Home</a></li>
                                        <li><a className="dropdown-item" href="#">Home 2</a></li>
                                        <li><a className="dropdown-item" href="#">Home 3</a></li>
                                    </ul>
                                </li> */}
                                <li className="nav-item">
                                    <Link className="nav-link" to="/about">
                                        About Us
                                    </Link>
                                </li>
                                <li className="nav-item dropdown">
                                    <a
                                        className="nav-link"
                                        href="#"
                                        role="button"
                                        data-bs-toggle="dropdown"
                                        aria-expanded="false"
                                    >
                                        Company
                                        <FaAngleDown />
                                    </a>
                                    <ul className="dropdown-menu">
                                        {/* <li><Link className="dropdown-item" to="#">Our Company</Link></li> */}
                                        <li><Link className="dropdown-item" to="/mission">Our Mission</Link></li>
                                        {/* <li><Link className="dropdown-item" to="#">Leadership</Link></li> */}
                                        <li><Link className="dropdown-item" to="/whychoose">Why Choose Us</Link></li>
                                        {/* <li><Link className="dropdown-item" to="#">Testimonials</Link></li> */}
                                        {/* <li><Link className="dropdown-item" to="#">Our Partners</Link></li> */}
                                        <li><Link className="dropdown-item" to="/career">Careers</Link></li>
                                        {/* <li><Link className="dropdown-item" to="#">Our Process</Link></li> */}
                                    </ul>       
                                </li>
                                <li className="nav-item">
                                    <Link className="nav-link" to="/service">
                                        Services
                                    </Link>
                                </li>
                                {/* <li className="nav-item">
                                    <Link className="nav-link" to="/blog">
                                        Blog
                                    </Link>
                                </li> */}
                                {/* <li className="nav-item">
                                    <a className="nav-link" href="#">
                                        News
                                    </a>
                                </li> */}
                                <li className="nav-item">
                                    <Link className="nav-link" to="/contact">
                                        Contact Us
                                    </Link>
                                </li>
                                {/* <li className="nav-item">
                                    <a className="nav-link" href="#">
                                        All Pages
                                    </a>
                                </li> */}
                            </ul>
                        </div>
                    </div>
                </nav>

            </header>
            {/* <header>
                <div className="container">
                    <nav>
                        <a href="javascript:void(0);"><img src={require('../../assets/images/logo.png')} /></a>
                        <ul>
                            <li><a href="javascript:void(0)">Demos</a>
                             <ul>
                                <li><a href="javascript:void(0);">Our Company</a></li>
                                <li><a href="javascript:void(0);">Our Mission</a></li>
                                <li><a href="javascript:void(0);">Leadership</a></li>
                                <li><a href="javascript:void(0);">Why Choose Us</a></li>
                                <li><a href="javascript:void(0);">Testimonials</a></li>
                                <li><a href="javascript:void(0);">Our Partners</a></li>
                                <li><a href="javascript:void(0);">Careers</a></li>
                                <li><a href="javascript:void(0);">Our Process</a></li>
                             </ul>
                            </li>
                            <li><Link href="javascript:void(0)">Company</Link></li>
                            <li><Link to="/service">Services</Link></li>
                            <li><Link href="javascript:void(0)">News</Link></li>
                            <li><Link href="javascript:void(0)">Contact Us</Link></li>
                            <li><Link href="javascript:void(0)">All Pages</Link></li>
                        </ul>
                    </nav>
                </div>
            </header> */}
        </>
    )
}

export default Header
